import React from 'react';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';

export default function WorkspaceFiltersBar({ search, onSearchChange, view, onViewChange }) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={1.25}
      alignItems={{ xs: 'stretch', md: 'center' }}
      sx={{ width: { xs: '100%', md: 'auto' } }}
    >
      <TextField
        size="small"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder="Search workspaces"
        aria-label="Search workspaces"
        sx={{ width: { xs: '100%', md: 320 } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRoundedIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      <ToggleButtonGroup
        exclusive
        size="small"
        value={view}
        onChange={(_event, nextView) => nextView && onViewChange(nextView)}
        aria-label="Workspace view"
        sx={{
          '& .MuiToggleButton-root': {
            flex: { xs: 1, md: '0 0 auto' },
            gap: 0.75,
            px: 1.25,
            textTransform: 'none',
          },
        }}
      >
        <ToggleButton value="cards" aria-label="Cards view">
          <GridViewRoundedIcon fontSize="small" />
          <Typography component="span" variant="caption" sx={{ fontWeight: 700 }}>Cards</Typography>
        </ToggleButton>
        <ToggleButton value="list" aria-label="List view">
          <ViewListRoundedIcon fontSize="small" />
          <Typography component="span" variant="caption" sx={{ fontWeight: 700 }}>List</Typography>
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  );
}
